import React from "react";
import type { NavIconKey } from "../types";
import { FallbackIcon, PersonSvg } from "./icons";
import type { ResultItem } from "./types";

export interface ResultRowProps {
  item: ResultItem;
  index: number;
  isSelected: boolean;
  onSelect: () => void;
  onHover: () => void;
  iconMap?: Partial<Record<NavIconKey, React.ReactElement>>;
}

export function ResultRow({ item, index, isSelected, onSelect, onHover, iconMap }: ResultRowProps) {
  const isPerson = item.kind === "person";

  function renderIcon() {
    if (item.kind === "person") {
      if (item.initials) {
        return <span style={{ fontSize: "0.75rem" }}>{item.initials}</span>;
      }
      return <PersonSvg />;
    }
    if (item.iconKey && iconMap?.[item.iconKey]) {
      return iconMap[item.iconKey];
    }
    return <FallbackIcon />;
  }

  return (
    <div
      role="option"
      id={`fn-us-result-${index}`}
      aria-selected={isSelected}
      data-index={index}
      tabIndex={-1}
      className="fn-us-result-row"
      onClick={onSelect}
      onMouseEnter={onHover}
    >
      <div
        className={`fn-us-result-icon ${isPerson ? "fn-us-result-icon--person" : "fn-us-result-icon--nav"}`}
      >
        {renderIcon()}
      </div>
      <div className="fn-us-result-label">
        <div className="fn-us-result-name">{item.label}</div>
        {/* Nav items carry their category in `subtitle` for grouping (see
            groupByCategory) but a group header already renders it — showing
            it again on every row here was redundant. */}
        {isPerson && item.subtitle && <div className="fn-us-result-subtitle">{item.subtitle}</div>}
      </div>
      <span className="fn-us-enter-hint">↵</span>
    </div>
  );
}
